/* eslint-disable */
const getters = {
  getSymptoms(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
